import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import button from '@edx/paragon/dist/Button';
import closeIcon from '../../assets/close-icon.svg';
import CustomTagModal from '../CustomTagModal/CustomTagModal';
import { hasSkills } from '../constants';

const TagsSection = ({
  title,
  placeholder,
  userCategories,
  categories,
  changeData,
  editButton,
  onCategoriesUpdate,
}) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // If categories have skills structure, extract the skills from userCategories
    if (hasSkills(categories)) {
      const extractedSkills = [];
      userCategories.forEach(category => {
        if (category.skills && category.skills.length) {
          extractedSkills.push(...category.skills);
        }
      });
      setSelectedCategories(extractedSkills);
    } else {
      setSelectedCategories(userCategories);
    }
  }, [userCategories, categories]);

  const handleCategoryDelete = id => {
    const newSelection = selectedCategories.filter(category => category.id !== id);
    setSelectedCategories(newSelection);
    if (onCategoriesUpdate) {
      onCategoriesUpdate(newSelection);
    }
  };

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleCategoriesSave = categories => {
    setSelectedCategories(categories);
    if (onCategoriesUpdate) {
      onCategoriesUpdate(categories);
    }
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <h2
          className={`tw-text-[16px] tw-font-medium ${changeData ? 'tw-text-neutral-1000' : 'tw-text-neutral-600'}`}
        >
          {title}
        </h2>

        <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-3">
          {selectedCategories.map(category => (
            <div key={category.id} className="tag tw-font-normal">
              {category.name}
              {changeData && (
                <button
                  onClick={() => handleCategoryDelete(category.id)}
                  className="tw-min-w-[18px]"
                >
                  <img src={closeIcon} alt="Close icon" />
                </button>
              )}
            </div>
          ))}
          {changeData && (
            <button
              onClick={handleToggleModal}
              className="tw-px-4 tw-py-2 tw-rounded-[24px] tw-bg-neutral-1000 tw-text-neutral-100"
            >
              {editButton}
            </button>
          )}
          {!selectedCategories.length && !changeData && (
            <span className="tw-text-[14px] tw-text-placeholder tw-font-medium">{placeholder}</span>
          )}
        </div>
      </div>
      <CustomTagModal
        isOpen={isModalOpen}
        onClose={handleToggleModal}
        title={title}
        categories={categories}
        userCategories={selectedCategories}
        onSave={handleCategoriesSave}
      />
    </>
  );
};

TagsSection.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  userCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      is_active: PropTypes.bool,
    }),
  ).isRequired,
  onCategoriesUpdate: PropTypes.func,
  categories: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        is_active: PropTypes.bool,
      }),
    ),
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        is_active: PropTypes.bool,
        skills: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            is_active: PropTypes.bool,
            category: PropTypes.arrayOf(
              PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                is_active: PropTypes.bool,
              }),
            ),
          }),
        ),
      }),
    ),
  ]).isRequired,
  changeData: PropTypes.bool,
  editButton: PropTypes.string,
};

TagsSection.defaultProps = {
  title: '',
  placeholder: '',
  userCategories: [],
  categories: [],
  changeData: false,
  editButton: 'Редагувати',
  onCategoriesUpdate: null,
};

export default TagsSection;
